import StudentGeneralInfo from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
    case 'studentNumber':
      return [key, `${val}`];  // stringify
    default:
      return [key, val];
  }
};

const create = (data) => new StudentGeneralInfo(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/AcademicInfo/StudentGeneralInfo/create.js